package net.gorillagroove.db

import kotlin.String
import net.gorillagroove.api.TrackApiId
import net.gorillagroove.api.TrackId

public data class FindLocalIdForApiId(
  public val id: TrackId,
  public val apiId: TrackApiId?
) {
  public override fun toString(): String = """
  |FindLocalIdForApiId [
  |  id: $id
  |  apiId: $apiId
  |]
  """.trimMargin()
}
